import { MESSAGE_TYPE } from '../../views/chat/actions';
import { REJECT_CODES } from '../../views/questionnaire/types';
import { APIMode } from '../../../api/types';
import options from '../../../helpers/options/defaults';
import { getConfigForTarget } from '../../views/questionnaire/config';

export const isContactAvailable = (state) => {
    if (!state.config || !state.config.widget || !state.config.widget.contactOptions) {
        return {
            available: false,
            reason: 'Incorrect contactOptions configuration object',
            level: 'error'
        };
    } else {
        return { available: true };
    }
};

export const isCMBAvailable = (state) => {
    if (!state.config || !state.config.widget || !state.config.widget.cmbOptions) {
        return {
            available: false,
            reason: 'Incorrect cmbOptions configuration object',
            level: 'error'
        };
    } else {
        if (
            !state.config.widget.cmbOptions.cmbImmediateAvailable &&
            !state.config.widget.cmbOptions.cmbDelayedAvailable
        ) {
            return {
                available: false,
                reason: 'Immediate and delayed == false',
                level: 'info'
            };
        }
        return { available: true };
    }
};

export const isChatAvailable = (state) => {
    if (!state?.config?.widget?.chatOptions || !state?.settings?.env?.serverURL) {
        return {
            available: false,
            reason: 'Incorrect chatOptions configuration object',
            level: 'error'
        };
    }
    return { available: true };
};

export const isChatSaveAvailable = (state) => {
    if (
        !state.config ||
        !state.config.widget ||
        !state.config.widget.chatOptions.chatSaveOptions ||
        Object.keys(state.config.widget.chatOptions.chatSaveOptions).length === 0
    ) {
        return {
            available: false,
            reason: 'Incorrect chatSave configuration object',
            level: 'error'
        };
    } else {
        if (
            !state.config.widget.chatOptions.afterChat ||
            !state.config.widget.chatOptions.afterChat.chatSaveAvailable
        ) {
            return {
                available: false,
                reason: 'afterChat.chatSaveAvailable == false',
                level: 'info'
            };
        }

        const available =
            state.chat.messages.filter(
                (m) =>
                    (m.type === MESSAGE_TYPE.MESSAGE && m.from === 'client') ||
                    (m.type === MESSAGE_TYPE.BOT_MESSAGE && m.from === 'client') ||
                    m.type === MESSAGE_TYPE.AGENT_JOINED
            ).length > 0;

        if (available) {
            return { available: true };
        } else {
            return {
                available: false,
                reason: 'No chat messages',
                level: 'info'
            };
        }
    }
};

export const isQuestionnaireAvailable = (state) => {
    const isAfterChat = () => {
        return (
            state.config &&
            state.config.widget &&
            state.config.widget.chatOptions.afterChat &&
            state.config.widget.chatOptions.afterChat.questionnaireAvailable
        );
    };

    const isOptionsAvailable = () => {
        return (
            state.config.widget.questionnaireOptions &&
            Object.keys(state.config.widget.questionnaireOptions).length !== 0
        );
    };

    const isStandalone = () => {
        return !state.widget.currentView;
    };

    if (isStandalone()) {
        if (isOptionsAvailable()) {
            return { available: true };
        } else {
            return {
                available: false,
                reason: 'Incorrect questionnaireOptions configuration object',
                level: 'info'
            };
        }
    } else if (isAfterChat()) {
        if (isOptionsAvailable()) {
            const isChatConditionsMet = () => {
                if (!getConfigForTarget('agent')) {
                    return {
                        available: false,
                        reason: 'Brak poprawnej konfiguracji',
                        code: REJECT_CODES.NO_QUESTIONNAIRE_CONFIG,
                        level: 'info'
                    };
                }
                const agentJoins = state.chat.messages.filter(
                    (m) => m.type === MESSAGE_TYPE.AGENT_JOINED || m.type === MESSAGE_TYPE.TRANSFER
                );
                if (agentJoins.length > 0) {
                    const lastJoin = agentJoins[agentJoins.length - 1];
                    if (lastJoin.type !== MESSAGE_TYPE.TRANSFER) {
                        const cmessages = state.chat.messages.filter(
                            (m) =>
                                m.type === MESSAGE_TYPE.MESSAGE &&
                                m.from === 'client' &&
                                m.localtimestamp &&
                                m.localtimestamp >= lastJoin.localtimestamp
                        );
                        const amessages = state.chat.messages.filter(
                            (m) =>
                                m.type === MESSAGE_TYPE.MESSAGE &&
                                m.from === 'agent' &&
                                m.localtimestamp &&
                                m.localtimestamp >= lastJoin.localtimestamp
                        );
                        if (cmessages.length > 0 && amessages.length > 0) {
                            const startTime = lastJoin.localtimestamp;
                            let sessionEnd = state.chat.messages.filter(
                                (m) => m.type === MESSAGE_TYPE.SESSION_END
                            )[0];
                            if (!sessionEnd) {
                                sessionEnd = {
                                    localtimestamp: new Date().valueOf()
                                };
                            } else if (sessionEnd.failure) {
                                return {
                                    available: false,
                                    reason: `Zakończenie sesji z powodu błędu: ${sessionEnd.message}`,
                                    code: REJECT_CODES.SESSION_FAIL,
                                    level: 'error'
                                };
                            }
                            const endTime = sessionEnd.localtimestamp;
                            const conversationTime = Math.floor((endTime - startTime) / 1000);

                            const getMinimumTime = (isMax) => {
                                if (isMax) {
                                    return state.config.widget.chatOptions.afterChat
                                        .questionnaireMinimumTimeMax
                                        ? state.config.widget.chatOptions.afterChat
                                              .questionnaireMinimumTimeMax
                                        : options.chatOptions.questionnaireMinimumTimeMax;
                                } else {
                                    return state.config.widget.chatOptions.afterChat
                                        .questionnaireMinimumTime
                                        ? state.config.widget.chatOptions.afterChat
                                              .questionnaireMinimumTime
                                        : options.chatOptions.questionnaireMinimumTime;
                                }
                            };
                            const minTime = getMinimumTime(lastJoin.max);

                            const result = conversationTime > minTime;
                            if (!result) {
                                return {
                                    available: false,
                                    reason: `Rozmowa trwała ${conversationTime}s`,
                                    code: REJECT_CODES.CONVERSATION_TOO_SHORT,
                                    level: 'info'
                                };
                            }

                            //--B2B 510 600 600
                            const isB2BHighSegment = state.chat.messages.filter(
                                (m) => m.max === true && m.message.indexOf('510 600 600') > -1
                            ).length
                                ? true
                                : false;
                            if (isB2BHighSegment) {
                                return {
                                    available: false,
                                    reason: 'B2B wysoki segment',
                                    code: REJECT_CODES.B2B_HIGH_SEGMENT,
                                    level: 'info'
                                };
                            }

                            return { available: true };
                        } else {
                            return {
                                available: false,
                                reason: 'Brak wiadomości od klienta',
                                code: REJECT_CODES.NO_CLIENT_MESSAGES,
                                level: 'info'
                            };
                        }
                    } else {
                        return {
                            available: false,
                            reason: 'Doradca nie dołączył do rozmowy po przekierowaniu',
                            code: REJECT_CODES.TRANSFER_WITHOUT_AGENT,
                            level: 'info'
                        };
                    }
                } else {
                    return {
                        available: false,
                        reason: 'Doradca nie dołączył do rozmowy',
                        code: REJECT_CODES.AGENT_NOT_JOINED,
                        level: 'info'
                    };
                }
            };

            const isBotConditionsMet = () => {
                if (!getConfigForTarget('bot')) {
                    return {
                        available: false,
                        reason: 'Brak poprawnej konfiguracji',
                        code: REJECT_CODES.NO_QUESTIONNAIRE_CONFIG,
                        level: 'info'
                    };
                }

                const messagesCondition = () => {
                    let agentMessageCounter = 0;
                    let clientMessageCounter = 0;
                    state.chat.messages.forEach((m) => {
                        if (m.type === MESSAGE_TYPE.BOT_MESSAGE && m.from === 'client') {
                            clientMessageCounter++;
                        } else if (m.type === MESSAGE_TYPE.BOT_MESSAGE && m.from === 'agent') {
                            agentMessageCounter++;
                        }
                    });
                    return clientMessageCounter > 1 && agentMessageCounter > 2;
                };

                if (messagesCondition()) {
                    return { available: true };
                } else {
                    return {
                        available: false,
                        reason: 'Nie spełnione zostały warunki dla wiadomości',
                        code: REJECT_CODES.BOT_USER_NOT_ENGAGED,
                        level: 'info'
                    };
                }
            };

            const isUsabilaCookiePresent = () => {
                if (state.main.isUsabilaCookiePresent) {
                    return {
                        available: false,
                        reason: 'Usabila cookie present',
                        code: REJECT_CODES.USABILA_COOKIE_PRESENT,
                        level: 'info'
                    };
                } else {
                    return { available: true };
                }
            };

            const result =
                state.chat.mode === APIMode.BOT ||
                (state.chat.mode === APIMode.CHAT_BOT && state.chat.agent.joined === false)
                    ? isBotConditionsMet()
                    : isChatConditionsMet();
            if (!result.available) {
                return result;
            } else {
                return isUsabilaCookiePresent();
            }
        } else {
            return {
                available: false,
                reason: 'Incorrect questionnaireOptions configuration object',
                level: 'info'
            };
        }
    } else {
        return {
            available: false,
            reason: 'Incorrect questionnaire configuration',
            level: 'info'
        };
    }
};
